import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import constants from '../constants';

const {
  Box,
  Heading,
  Paragraph,
  Divider,
  HorizontalStack,
  Popover,
  PopoverContent,
  PopoverTrigger,
} = designSystem;
const { common } = constants;

function SearchPreview({ title, path, description, image = '' }) {
  return (
    <div className="ws-search-preview">
      <Box padding="spacing-xs" paddingLeft="spacing-m" paddingRight="spacing-m">
        <HorizontalStack gap="spacing-2-xs" verticalAlign="center">
          <div className="ws-search-preview__body">
            <div className="ws-search-preview__title">
              <Heading type="heading-5" appearance="accent">
                {title?.length > common.MAX_TITLE_TAG_LENGTH
                  ? `${title.substring(0, common.MAX_TITLE_TAG_LENGTH)}...`
                  : title}
              </Heading>
            </div>
            <Paragraph size="small" appearance="medium-emphasis" isClipped>
              {path}
            </Paragraph>
          </div>
          {image && (
            <Popover appearance="dark" placement="bottom-right" width={345}>
              <PopoverTrigger>
                <img src={image} alt={title} className="ws-search-preview__image" />
              </PopoverTrigger>
              <PopoverContent>
                <img src={image} alt={title} className="ws-search-preview__preview-image" />
              </PopoverContent>
            </Popover>
          )}
        </HorizontalStack>
        <Box marginTop="spacing-2-xs" marginBottom="spacing-2-xs">
          <Divider />
        </Box>
        <div className="ws-search-preview__description">
          <Paragraph>
            {description?.length > common.MAX_DESCRIPTION_LENGTH
              ? `${description.substring(0, common.MAX_DESCRIPTION_LENGTH)}...`
              : description}
          </Paragraph>
        </div>
      </Box>
    </div>
  );
}

SearchPreview.propTypes = {
  title: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string,
};

export default SearchPreview;
